import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SharedSelect = _resolveComponent("SharedSelect")!
  const _component_UIInput = _resolveComponent("UIInput")!
  const _component_UIButton = _resolveComponent("UIButton")!
  const _component_SharedInputCurrency = _resolveComponent("SharedInputCurrency")!
  const _component_SharedWindow = _resolveComponent("SharedWindow")!

  return (_openBlock(), _createBlock(_component_SharedWindow, {
    title: "Withdrawal",
    "is-big": _ctx.isBig,
    "is-center": true,
    onClose: _ctx.handleClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('wrapper'))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.b('fields'))
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.b('field-coin'))
          }, [
            _createElementVNode("p", {
              class: _normalizeClass(_ctx.b('field-label'))
            }, _toDisplayString(_ctx.$t("Монета")), 3),
            _createVNode(_component_SharedSelect, {
              view: "light",
              options: _ctx.displayedCurrencyOptions,
              value: _ctx.coinId,
              "onUpdate:value": [
                _cache[0] || (_cache[0] = ($event: any) => ((_ctx.coinId) = $event)),
                _ctx.loadChains
              ],
              isCryptoIcon: true,
              icon: _ctx.displayedCurrencyIcon
            }, null, 8, ["options", "value", "icon", "onUpdate:value"])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.b('field-chain'))
          }, [
            _createElementVNode("p", {
              class: _normalizeClass(_ctx.b('field-label'))
            }, _toDisplayString(_ctx.$t("Выберите сеть")), 3),
            _createVNode(_component_SharedSelect, {
              isReadonly: !_ctx.displayedChainOptions,
              view: "light",
              options: _ctx.displayedChainOptions,
              value: _ctx.chain,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.chain) = $event))
            }, null, 8, ["isReadonly", "options", "value"])
          ], 2)
        ], 2),
        (_ctx.chain)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(_ctx.b('field'))
            }, [
              _createElementVNode("p", {
                class: _normalizeClass(_ctx.b('field-label'))
              }, _toDisplayString(_ctx.$t("Адрес кошелька")), 3),
              _createVNode(_component_UIInput, {
                view: "light",
                modelValue: _ctx.address,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.address) = $event))
              }, null, 8, ["modelValue"])
            ], 2))
          : _createCommentVNode("", true),
        (_ctx.chain)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(_ctx.b('field'))
            }, [
              _createElementVNode("p", {
                class: _normalizeClass(_ctx.b('field-label'))
              }, _toDisplayString(_ctx.$t("Адрес Таг кошелька")), 3),
              _createVNode(_component_UIInput, {
                view: "light",
                modelValue: _ctx.addressTag,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.addressTag) = $event))
              }, null, 8, ["modelValue"])
            ], 2))
          : _createCommentVNode("", true),
        (_ctx.chain)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass(_ctx.b('field-amount'))
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.b('field-label'))
              }, [
                _createTextVNode(_toDisplayString(_ctx.$t("Сумма")) + " ", 1),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.b('field-label-actions'))
                }, [
                  (_ctx.chain)
                    ? (_openBlock(), _createBlock(_component_UIButton, {
                        key: 0,
                        label: "МИН",
                        view: "max",
                        onClick: _ctx.handleMin
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_UIButton, {
                    label: "МАКС",
                    view: "max",
                    onClick: _ctx.handleMax
                  }, null, 8, ["onClick"])
                ], 2)
              ], 2),
              _createVNode(_component_SharedInputCurrency, {
                placeholder: "Введите сумму",
                currency: _ctx.displayedCurrency,
                value: _ctx.amount,
                "onUpdate:value": _ctx.handleAmountChange
              }, null, 8, ["currency", "value", "onUpdate:value"]),
              (_ctx.errorAmountMessage)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    class: _normalizeClass(_ctx.b('field-error'))
                  }, _toDisplayString(_ctx.errorAmountMessage), 3))
                : _createCommentVNode("", true)
            ], 2))
          : _createCommentVNode("", true),
        (!_ctx.errorAmountMessage)
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              class: _normalizeClass(_ctx.b('field-result'))
            }, [
              _createElementVNode("p", {
                class: _normalizeClass(_ctx.b('field-label-result'))
              }, [
                _createTextVNode(_toDisplayString(_ctx.$t("Вы получите")) + " ", 1),
                _createElementVNode("b", {
                  class: _normalizeClass(_ctx.b('result-amount'))
                }, _toDisplayString(_ctx.resultAmount), 3),
                _createTextVNode(" " + _toDisplayString(_ctx.displayedCurrency?.currency?.name.toUpperCase() ||
            _ctx.displayedCurrency?.name.toUpperCase()), 1)
              ], 2)
            ], 2))
          : _createCommentVNode("", true),
        (_ctx.chain)
          ? (_openBlock(), _createElementBlock("div", {
              key: 4,
              class: _normalizeClass(_ctx.b('fields'))
            }, [
              _createVNode(_component_UIButton, {
                label: "Вывести",
                view: "main",
                disabled: _ctx.isDisabled,
                onClick: _ctx.handleWithdraw
              }, null, 8, ["disabled", "onClick"])
            ], 2))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _: 1
  }, 8, ["is-big", "onClose"]))
}